// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import Modal from 'react-modal';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import EditTournamentTeam from '../editTournamentTeam';
import {Link} from 'react-router-dom';
import { colors, btn, card, table, modal, empty, spinner as spinnerStyle } from '../../../../style/common/partnerStyle';

var Spinner = require('react-spinkit');
// import {
//   WhatsappShareButton,
//   WhatsappIcon,
// } from 'react-share';


class ViewCompetitionTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      competition_id: props.competition_id,
      teams: [],
      groups: [],
      game_types: [13, 14, 15],
      team_list: [],
      age_groups: [],
      filtered_teams: [],
      gametype: '',
      open_add_team: false,
      current_team_name: '',
      tournament_team_details: {
        tournament_id: props.id,
        competition_id: props.competition_id,
        name: '',
        group: '',
        game_type: '',
        logo: '',
        jersey: '',
        age_group: '',
        amount_paid: 0,
      },
      viewplayers: false,
      team_name: '',
      team_id: '',
      selected_team: '',
      search_field: false,
      team_search: false,
      search_plus: true,
      addMemberView: false,
      data_uploaded: false,
      data_error: false,
      addNewTeamView: false,
      editTeamView: false,
      is_loading: false,
      is_team_competition: false,
      playerlist: [],
    };
    this.handleChange = this.handleChange.bind(this);
    // this.handleFileLogo = this.handleFileLogo.bind(this);
    // this.handleFileJersey = this.handleFileJersey.bind(this);
    this.getTeamList = this.getTeamList.bind(this);
    this.renderPlayerViewList = this.renderPlayerViewList.bind(this);
    this.showplayerlist = this.showplayerlist.bind(this);
    this.createImageFromInitials = this.createImageFromInitials.bind(this);
  }

  componentDidMount() {
    this.setState({ is_loading: true });
    this.getTeamList();
    console.log(this.state);
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var j = 0; j < 6; j++) { color += letters[Math.floor(Math.random() * 16)]; }
    return color;
  }

  createImageFromInitials(size, name, color) {
    let initials;
    initials = name.substring(0, 1);
    name = initials.toUpperCase();
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = canvas.height = size;
    context.fillStyle = "#ffffff";
    context.fillRect(0, 0, size, size);
    context.fillStyle = `${color}50`;
    context.fillRect(0, 0, size, size);
    context.fillStyle = color;
    context.textBaseline = 'middle';
    context.textAlign = 'center';
    context.font = `${size / 2}px Roboto`;
    context.fillText(name, (size / 2), (size / 2));
    return canvas.toDataURL();
  }

  getTeamList() {
    var mobile_no = this.state.mobile_no;
    const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'competition_id': this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({ team_list: data.teamlist, is_loading: false, is_team_competition: data.is_team_competition }))
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleChange(event) {
    const name = event.target.name;
    console.log(event.target.name, event.target.value);
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    new_selected_one[name] = event.target.value;
    this.setState({ tournament_team_details: new_selected_one });
  }

  // handleFileLogo(selectorFiles: FileList){
  //   var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
  //   new_selected_one['logo'] = selectorFiles[0]
  //   this.setState({tournament_team_details: new_selected_one});
  // }

  handleAddTeam() {
    event.preventDefault();
    var new_selected_one = Object.assign({}, this.state.tournament_team_details);
    new_selected_one['id'] = this.state.selected_team.id;
    this.postaddTournamentTeam(new_selected_one, this.props);
  }

  toAddPlayerView(team) {
    console.log(team.team.id, team.team.name);
    this.setState({ team_name: team.team.name, team_id: team.team.id, addMemberView: !this.state.addMemberView });
  }

  // handleFileJersey(selectorFiles: FileList){
  //   var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
  //   new_selected_one['jersey'] = selectorFiles[0]
  //   this.setState({tournament_team_details: new_selected_one});
  // }

  addTeam(team) {
    this.setState({ selected_team: team, show_team_list: false, search_field: false });
  }

  toAddTeamView() {
    this.setState({ addNewTeamView: !this.state.addNewTeamView });
    this.getTeamList();
  }

  toEditTeamView() {
    this.setState({ editTeamView: !this.state.editTeamView });
    this.getTeamList();
  }

  showplayerlist(team) {
    this.setState({ viewplayers: true, playerlist: team.players });
  }

  renderPlayerViewList() {
    return (
      <Modal
        isOpen={this.state.viewplayers}
        onRequestClose={() => { this.setState({ viewplayers: false }); }}
        ariaHideApp={false}
        style={{
          overlay: { backgroundColor: 'rgba(17,24,39,.45)', zIndex: 1000 },
          content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%,-50%)',
            padding: 0, border: 'none', borderRadius: 16,
            boxShadow: '0 8px 40px rgba(0,0,0,.18)',
            width: '90%', maxWidth: 380, maxHeight: '80vh', overflow: 'auto',
          },
        }}
      >
        <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 20px', borderBottom: `1px solid ${colors.border}` }}>
            <h4 style={{ margin: 0, fontSize: 15, fontWeight: 700, color: colors.text }}>Player List</h4>
            <button
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: colors.muted, fontSize: 18, lineHeight: 1 }}
              onClick={() => this.setState({ viewplayers: false })}
            >✕</button>
          </div>
          <div style={{ padding: '12px 20px' }}>
            {this.state.playerlist.length ? (
              this.state.playerlist.map((player, index) => (
                <div key={index} style={{
                  padding: '10px 0',
                  borderBottom: index < this.state.playerlist.length - 1 ? `1px solid ${colors.border}` : 'none',
                  fontSize: 13, color: colors.text,
                  display: 'flex', alignItems: 'center', gap: 10,
                }}>
                  <span style={{
                    width: 28, height: 28, borderRadius: '50%', background: colors.brandLt,
                    color: colors.brand, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 700, flexShrink: 0,
                  }}>
                    {index + 1}
                  </span>
                  {player.name}
                </div>
              ))
            ) : (
              <div style={{ textAlign: 'center', color: colors.muted, fontSize: 13, padding: '16px 0' }}>No players added yet</div>
            )}
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    if(this.state.team_list.length > 0) {
      var buddy = this.state.team_list.filter(info => info.team && info.team.buddy != null);
      var training_time = this.state.team_list.filter(info => info.team && info.team.training_time != null);
      var training_days = this.state.team_list.filter(info => info.team && info.team.training_days != null);
    }

    const visibleTeams = this.state.team_list.filter(x => x.team.name != 'BYE' && x.team_type != 'BYE');

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

        {/* Spinner */}
        {this.state.is_loading && (
          <div style={spinnerStyle.wrap}>
            <Spinner name="line-scale-pulse-out-rapid" color={spinnerStyle.color} />
          </div>
        )}

        {/* Player list modal */}
        {this.state.viewplayers && this.renderPlayerViewList()}

        {/* Teams table */}
        {this.state.team_list.length > 0 && (
          <div>
            <div style={{ ...card.header, padding: '16px 20px' }}>
              <h3 style={{ ...card.title, margin: 0 }}>Teams</h3>
            </div>
            <div style={table.wrap}>
              <table style={table.table}>
                <thead>
                  <tr>
                    <th style={table.th}>Name</th>
                    {/*<th style={table.th}>Category</th>*/}
                    {buddy && buddy.length > 0 && <th style={table.th}>Coach</th>}
                    {training_days && training_days.length > 0 && <th style={table.th}>Training Days</th>}
                    {training_time && training_time.length > 0 && <th style={table.th}>Training Time</th>}
                    <th style={table.th}>Group</th>
                    {!this.state.is_team_competition && <th style={table.th}>Amount Paid</th>}
                    <th style={table.th}>Players</th>
                    <th style={table.th}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {visibleTeams.map((team, index) => (
                    <tr key={index} style={index % 2 === 1 ? table.trAlt : {}}>
                      <td style={table.tdBold}>{team.team && team.team.name}</td>
                      {buddy && buddy.length > 0 && <td style={table.td}>{team.team.buddy}</td>}
                      {training_days && training_days.length > 0 && <td style={table.td}>{team.team.training_days}</td>}
                      {training_time && training_time.length > 0 && <td style={table.td}>{team.team.training_time}</td>}
                      {/*<td style={table.td}>{team.age_groups && team.age_groups.name}</td>*/}
                      <td style={table.td}>{team.group}</td>
                      {!this.state.is_team_competition && <td style={table.tdAmount}>{team.amount_paid}</td>}
                      <td style={table.td}>
                        <button
                          type="button"
                          onClick={() => { this.showplayerlist(team); }}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: colors.brand, fontWeight: 600, fontSize: 13, padding: 0, fontFamily: 'inherit' }}
                        >
                          {team.no_of_players} players
                        </button>
                      </td>
                      <td style={{ ...table.td, whiteSpace: 'nowrap' }}>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                          {/* Add player */}
                          <button
                            type="button"
                            title="Add player"
                            onClick={() => { this.toAddPlayerView(team); }}
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px 6px', color: colors.brand, fontSize: 18, lineHeight: 1 }}
                          >
                            <i className="fa fa-user-plus" />
                          </button>
                          {/* Edit */}
                          <a href={`../../#/crud/editCompetitionTeam/${team.id}`} title="Edit" style={{ color: colors.muted, fontSize: 18, lineHeight: 1, padding: '4px 6px' }}>
                            <i className="fa fa-edit" />
                          </a>
                          {/* Delete */}
                          <a href={`../../#/crud/deleteCompetitionTeam/${team.id}`} title="Delete" style={{ color: colors.danger, fontSize: 18, lineHeight: 1, padding: '4px 6px' }}>
                            <i className="fa fa-trash" />
                          </a>
                          {/*<WhatsappShareButton className="comp_action_button" title={"Add your team members here : "} url={`https://www.sporthood.in/add-tournament-players/${team.public_id}`}><WhatsappIcon size={30} round={true} /></WhatsappShareButton>*/}
                          {/* External link */}
                          <a href={`https://www.sporthood.in/add-tournament-players/${team.public_id}`} title="Share link" target="_blank" style={{ color: colors.muted, fontSize: 18, lineHeight: 1, padding: '4px 6px' }}>
                            <i className="fa fa-external-link-square" />
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Empty state */}
        {!this.state.is_loading && this.state.team_list.length === 0 && (
          <div style={empty.wrap}>
            <div style={empty.icon}>👥</div>
            <div style={empty.title}>No Teams Yet</div>
            <div style={empty.text}>Add teams to this competition to get started.</div>
          </div>
        )}

        {/* Add member view */}
        {this.state.addMemberView && (
          <div style={{ marginTop: 16 }}>
            <AddMember
              team_id={this.state.team_id}
              team_name={this.state.team_name}
              tournament_id={this.state.tournament_team_details.tournament_id}
              competition_id={this.state.competition_id}
            />
          </div>
        )}

      </div>
    );
  }
}

export default ViewCompetitionTeam;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionTeam/index.js